import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { AuthProvider } from '@/features/auth'
import { RevenueCatProvider } from '@/providers/revenuecat-provider'
import { ErrorBoundary } from '@/components/error-boundary'
import { BrowserCheck } from '@/components/browser-check'
import { AppRoutes } from './routes'

export function App() {
  return (
    <BrowserCheck>
      <ErrorBoundary>
        <HelmetProvider>
          <BrowserRouter>
            <AuthProvider>
              <RevenueCatProvider>
                <AppRoutes />
              </RevenueCatProvider>
            </AuthProvider>
          </BrowserRouter>
        </HelmetProvider>
        <SpeedInsights />
      </ErrorBoundary>
    </BrowserCheck>
  )
}
